export const statusInfo = {
  draftMessage:
    'Guardado automático: cuando trabajas en un borrador de una plantilla no publicada los cambios que hagas se verán reflejados en el listado de plantillas.',

  publishedMessage:
    'Guardado automático: estás trabajando sobre un borrador de la versión publicada. Los cambios que hagas se guardarán automáticamente pero sólo seran publicados al actualizar.',
}
